import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/ImageFrame/ProductBagIcon.tsx
import { PRODUCT_BAG_FILLED_PATH } from "./productBagPath.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ProductBagIcon({ variant, size }) {
  if (variant === "filled") {
    return /* @__PURE__ */ jsx("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ jsx("path", { d: PRODUCT_BAG_FILLED_PATH }) });
  }
  return /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsx("path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" }),
    /* @__PURE__ */ jsx("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
    /* @__PURE__ */ jsx("path", { d: "M16 10a4 4 0 0 1-8 0" })
  ] });
}
ProductBagIcon.displayName = "ProductBagIcon";
export {
  ProductBagIcon
};
//# sourceMappingURL=ProductBagIcon.mjs.map